export default __webpack_public_path__ + "static/helclacase2-a7b3b332b34bf0a9dde8bc7e7fb6eabe.png";